<template>
  <Breadcrumbs />
  <div class="container">
    <BaseTitle>{{ $t("shops.shops-from-a-z") }} </BaseTitle>
    <AlphabetGrid />
  </div>
  <ShopsGrid
    :input="{ searchFilter }"
    :pagination="{ limit: 20, offset: 0 }"
    :title="shopsTitle"
    :show-load-more="true"
  />
</template>

<script setup lang="ts">
import { SearchFilter } from "~/graphql/generated";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/winkels",
    fr: "/magasins",
    nl: "/winkels",
  },
});

const activeChar = useRouteQuery("startsWith", "", {
  transform: String,
});

const searchFilter = computed(
  () => SearchFilter[activeChar.value as keyof typeof SearchFilter],
);

const { t } = useI18n();
const shopsTitle = computed(() => {
  if (activeChar.value)
    return t("shops.shops-starting-with", [activeChar.value]);
  return t("shops.title");
});
</script>

<style lang="scss" scoped></style>
